export const learnMetadata = {
  title: 'Breathwork for Athletes: BOLT Score & CO₂ Tolerance | Ayro',
  description: 'Learn about breathwork for athletic performance, how to measure your BOLT score, and the difference between CO₂ tolerance and VO₂ max.',
};

export function articleHeadingId(text) {
  return text.toLowerCase().replace(/₂/g, '2').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
